import {hAreaCodeEnum, hLanguageEnum} from 'hiya-common/src/reducers/env'
import {getSize1} from 'hiya-common/src/utils'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'
import {isEmpty} from 'lodash'
import 默认邀请头像 from './images/默认邀请头像.png'
import 默认头像1 from './images/默认头像1.png'
import 默认头像2 from './images/默认头像2.png'
import 默认头像3 from './images/默认头像3.png'

export {默认邀请头像}

export const GiftId = '12831'

export const ShareImg = {
  [hAreaCodeEnum.ar]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495934230`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495932974`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495934230`,
  },
  [hAreaCodeEnum.id]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495942538`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495942716`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495942538`,
  },
  [hAreaCodeEnum.vi]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495934811`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495933510`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495934811`,
  },
  [hAreaCodeEnum.tp]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495935638`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495932717`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495935638`,
  },
  [hAreaCodeEnum.th]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495935268`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495933805`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495935268`,
  },
  [hAreaCodeEnum.hi]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495935638`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495932717`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495935638`,
  },
  [hAreaCodeEnum.pk]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495935638`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495932717`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495935638`,
  },
  [hAreaCodeEnum.tr]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495934473`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495933268`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495934473`,
  },
  [hAreaCodeEnum.ms]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495935417`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495933959`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495935417`,
  },
  [hAreaCodeEnum.hk]: {
    previewImg: `${HostMaps.prod.img01}/img/png/id/537495935638`,
    in_image: `${HostMaps.prod.img01}/img/png/id/537495932717`,
    external_image: `${HostMaps.prod.img01}/img/png/id/537495935638`,
  },
}

export enum GenderEnum {
  无性别 = 0,
  女性,
  男性,
}

export enum ACT_STATUS {
  预热期 = 0,
  进行中,
  回顾期,
  其他,
}

export enum TASK_STATUS {
  未完成,
  已完成未领取,
  已完成已领取,
}

export enum PAGE_NAME {
  主页 = 'CPPage',
  规则页 = 'CPRule',
  榜单页 = 'CPRank',
}

export enum RECOMMEND_STATUS {
  可邀请 = 0,
  已邀请,
  被拒绝,
  已同意,
  不可绑定,
}

export const DefaultRankList = [
  {
    member_a: {
      name: '---',
      id: '---',
      avatar: 默认头像1,
    },
    member_b: {
      name: '---',
      id: '---',
      avatar: 默认头像1,
    },
    rank: 1,
    score: '---',
  },
  {
    member_a: {
      name: '---',
      id: '---',
      avatar: 默认头像2,
    },
    member_b: {
      name: '---',
      id: '---',
      avatar: 默认头像2,
    },
    rank: 2,
    score: '---',
  },
  {
    member_a: {
      name: '---',
      id: '---',
      avatar: 默认头像3,
    },
    member_b: {
      name: '---',
      id: '---',
      avatar: 默认头像3,
    },
    rank: 3,
    score: '---',
  },
]
